module.exports = __webpack_public_path__ + "static/Map-8599ff54e2b252f42e8fc25328dca8f7.jpg";